import { IconProps } from '@helpers/Models';

export const CheckCircleFilledIcon = ({
  width = 18,
  height = 18,
  fill = '#004834',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
      fill={fill}
    />
  </svg>
);

export const TickIcon = ({
  width = 17,
  height = 12,
  fill = '#004834',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.9782 1.60163L5.97819 11.6016C5.89109 11.689 5.7876 11.7584 5.67364 11.8057C5.55969 11.853 5.43751 11.8774 5.31413 11.8774C5.19074 11.8774 5.06856 11.853 4.95461 11.8057C4.84065 11.7584 4.73716 11.689 4.65006 11.6016L0.275064 7.22663C0.187858 7.13942 0.118682 7.03589 0.0714867 6.92195C0.0242912 6.80801 1.29947e-09 6.68589 0 6.56256C-1.29947e-09 6.43924 0.0242912 6.31712 0.0714867 6.20318C0.118682 6.08924 0.187858 5.98571 0.275064 5.8985C0.36227 5.8113 0.465798 5.74212 0.579738 5.69492C0.693678 5.64773 0.815799 5.62344 0.939126 5.62344C1.06245 5.62344 1.18457 5.64773 1.29851 5.69492C1.41245 5.74212 1.51598 5.8113 1.60319 5.8985L5.31491 9.61022L14.6516 0.275064C14.8277 0.0989432 15.0666 0 15.3157 0C15.5648 0 15.8036 0.0989432 15.9797 0.275064C16.1559 0.451184 16.2548 0.690055 16.2548 0.939126C16.2548 1.1882 16.1559 1.42707 15.9797 1.60319L15.9782 1.60163Z"
      fill={fill}
    />
  </svg>
);

export const GiftBoxIcon = ({
  width = 20,
  height = 20,
  fill = '#004834',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 19.0625V8.0625H0V2.0625H5.2C5.11667 1.9125 5.0625 1.75417 5.0375 1.5875C5.0125 1.42083 5 1.24583 5 1.0625C5 0.229167 5.29167 -0.479167 5.875 -1.0625C6.45833 -1.64583 7.16667 -1.9375 8 -1.9375C8.38333 -1.9375 8.74167 -1.86667 9.075 -1.725C9.40833 -1.58333 9.71667 -1.3875 10 -1.1375C10.2833 -1.40417 10.5917 -1.60417 10.925 -1.7375C11.2583 -1.87083 11.6167 -1.9375 12 -1.9375C12.8333 -1.9375 13.5417 -1.64583 14.125 -1.0625C14.7083 -0.479167 15 0.229167 15 1.0625C15 1.24583 14.9833 1.41667 14.95 1.575C14.9167 1.73333 14.8667 1.89583 14.8 2.0625H20V8.0625H18V19.0625H2ZM11.2875 0.35C11.0958 0.541667 11 0.779167 11 1.0625C11 1.34583 11.0958 1.58333 11.2875 1.775C11.4792 1.96667 11.7167 2.0625 12 2.0625C12.2833 2.0625 12.5208 1.96667 12.7125 1.775C12.9042 1.58333 13 1.34583 13 1.0625C13 0.779167 12.9042 0.541667 12.7125 0.35C12.5208 0.158333 12.2833 0.0625 12 0.0625C11.7167 0.0625 11.4792 0.158333 11.2875 0.35ZM7 1.0625C7 1.34583 7.09583 1.58333 7.2875 1.775C7.47917 1.96667 7.71667 2.0625 8 2.0625C8.28333 2.0625 8.52083 1.96667 8.7125 1.775C8.90417 1.58333 9 1.34583 9 1.0625C9 0.779167 8.90417 0.541667 8.7125 0.35C8.52083 0.158333 8.28333 0.0625 8 0.0625C7.71667 0.0625 7.47917 0.158333 7.2875 0.35C7.09583 0.541667 7 0.779167 7 1.0625ZM2 4.0625V6.0625H9V4.0625H2ZM9 17.0625V8.0625H4V17.0625H9ZM11 17.0625H16V8.0625H11V17.0625ZM18 6.0625V4.0625H11V6.0625H18Z"
      fill={fill}
    />
  </svg>
);

export const SecurityShieldIcon = ({
  width = 20,
  height = 24,
  fill = '#004834',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.8 15.6H11.4L10.71 11.73C11.11 11.53 11.425 11.24 11.655 10.86C11.885 10.48 12 10.06 12 9.6C12 8.94 11.765 8.375 11.295 7.905C10.825 7.435 10.26 7.2 9.6 7.2C8.94 7.2 8.375 7.435 7.905 7.905C7.435 8.375 7.2 8.94 7.2 9.6C7.2 10.06 7.315 10.48 7.545 10.86C7.775 11.24 8.09 11.53 8.49 11.73L7.8 15.6ZM9.6 24C6.82 23.3 4.525 21.705 2.715 19.215C0.905 16.725 0 13.96 0 10.92V3.6L9.6 0L19.2 3.6V10.92C19.2 13.96 18.295 16.725 16.485 19.215C14.675 21.705 12.38 23.3 9.6 24Z"
      fill={fill}
    />
  </svg>
);

export const StarIcon = ({
  width = 18,
  height = 18,
  fill = '#1A1A1A',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.85098 13.5437L9.00098 11.6438L12.151 13.5688L11.326 9.96875L14.101 7.56875L10.451 7.24375L9.00098 3.84375L7.55098 7.21875L3.90098 7.54375L6.67598 9.96875L5.85098 13.5437ZM2.82598 17.7188L4.45098 10.6938L-0.999023 5.96875L6.20098 5.34375L9.00098 -1.28125L11.801 5.34375L19.001 5.96875L13.551 10.6938L15.176 17.7188L9.00098 13.9938L2.82598 17.7188Z"
      fill={fill}
    />
  </svg>
);

export const DollarIcon = ({
  width = 20,
  height = 20,
  fill = '#000A16',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.1 17H10.85V15.75C11.6833 15.6 12.4 15.275 13 14.775C13.6 14.275 13.9 13.5333 13.9 12.55C13.9 11.85 13.7 11.2083 13.3 10.625C12.9 10.0417 12.1 9.53333 10.9 9.1C9.9 8.76667 9.20833 8.475 8.825 8.225C8.44167 7.975 8.25 7.63333 8.25 7.2C8.25 6.76667 8.40417 6.425 8.7125 6.175C9.02083 5.925 9.46667 5.8 10.05 5.8C10.5833 5.8 11 5.92917 11.3 6.1875C11.6 6.44583 11.8167 6.76667 11.95 7.15L13.55 6.5C13.3667 5.91667 13.0292 5.40833 12.5375 4.975C12.0458 4.54167 11.5 4.3 10.9 4.25V3H9.15V4.25C8.31667 4.43333 7.66667 4.8 7.2 5.35C6.73333 5.9 6.5 6.51667 6.5 7.2C6.5 7.98333 6.72917 8.61667 7.1875 9.1C7.64583 9.58333 8.36667 10 9.35 10.35C10.4 10.7333 11.1292 11.075 11.5375 11.375C11.9458 11.675 12.15 12.0667 12.15 12.55C12.15 13.1 11.9542 13.5042 11.5625 13.7625C11.1708 14.0208 10.7 14.15 10.15 14.15C9.6 14.15 9.1125 13.9792 8.6875 13.6375C8.2625 13.2958 7.95 12.7833 7.75 12.1L6.1 12.75C6.33333 13.55 6.69583 14.1958 7.1875 14.6875C7.67917 15.1792 8.31667 15.5167 9.1 15.7V17ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
      fill={fill}
    />
  </svg>
);

export const MailIcon = ({
  width = 20,
  height = 16,
  fill = '#000A16',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H2ZM10 9L2 4V14H18V4L10 9ZM10 7L18 2H2L10 7ZM2 4V2V14V4Z"
      fill={fill}
    />
  </svg>
);

export const SortIcon = ({
  width = 15,
  height = 19,
  fill = '#6B7280',
  className,
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.904 10.1538V2.873L1.06925 5.70775L0 4.65375L4.65375 0L9.30775 4.65375L8.2385 5.70775L5.40375 2.873V10.1538H3.904ZM10.3365 19L5.68275 14.3462L6.752 13.2923L9.5865 16.127V8.84625H11.0865V16.127L13.9212 13.2923L14.9902 14.3462L10.3365 19Z"
      fill={fill}
    />
  </svg>
);
